import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Camera as CameraIcon } from 'lucide-react';
import { useCameras, useStreamHealth } from '@/hooks/queries';
import { LivePlayer } from '@/components/LivePlayer';
export function Live() {
    const cameras = useCameras();
    const streamHealth = useStreamHealth();
    if (cameras.isLoading) {
        return _jsx("div", { className: "card-empty", children: "Loading live feeds\u2026" });
    }
    if (cameras.isError) {
        return _jsx("div", { className: "card-empty", children: "Failed to load live feeds." });
    }
    const runningRtsp = (cameras.data ?? []).filter((c) => c.ingestion_enabled && (c.source_type ?? 'rtsp') === 'rtsp');
    const healthByCamera = new Map((streamHealth.data ?? []).map((h) => [h.camera_id, h]));
    const healthLabel = {
        ready: 'playable',
        not_ready: 'starting',
        not_registered: 'unregistered',
        disabled: 'stopped',
        not_applicable: 'n/a',
        error: 'error',
    };
    const healthClass = {
        ready: 'stream-health-ready',
        not_ready: 'stream-health-warn',
        not_registered: 'stream-health-warn',
        disabled: 'stream-health-neutral',
        not_applicable: 'stream-health-neutral',
        error: 'stream-health-error',
    };
    return (_jsx(_Fragment, { children: _jsxs("div", { className: "card", children: [_jsxs("div", { className: "card-header", children: [_jsxs("span", { className: "card-title", children: [_jsx(CameraIcon, { size: 16 }), " Live Wall"] }), _jsxs("span", { className: "model-badge", children: [runningRtsp.length, " active RTSP"] })] }), runningRtsp.length === 0 ? (_jsx("div", { className: "card-empty", children: "No active RTSP feeds. Uploaded videos are available in Analysis." })) : (_jsx("div", { className: "live-grid", children: runningRtsp.map((camera) => {
                        const health = healthByCamera.get(camera.camera_id);
                        const state = health?.state ?? 'unknown';
                        const streamTagClass = healthClass[state] ?? 'stream-health-pending';
                        const streamTagLabel = healthLabel[state] ?? 'health pending';
                        return (_jsxs("div", { className: "live-tile", children: [_jsxs("div", { className: "live-tile-head", children: [_jsxs("div", { style: { display: 'flex', flexDirection: 'column', gap: 4 }, children: [_jsx("span", { children: camera.name || camera.camera_id }), _jsxs("div", { style: { display: 'flex', gap: 6, flexWrap: 'wrap' }, children: [_jsx("span", { className: "tag status-running", children: "running" }), _jsx("span", { className: `tag stream-health ${streamTagClass}`, children: streamTagLabel })] })] }), _jsx("span", { className: "mono-pill", children: camera.camera_id })] }), _jsx(LivePlayer, { cameraId: camera.camera_id })] }, camera.camera_id));
                    }) }))] }) }));
}
